module.exports = __webpack_public_path__ + "static/banner-6354afad5c65395774cc405f6785a170.jpg";